export default "__VITE_ASSET__C1aAnscD__"